import { render, staticRenderFns } from "./MoleculeEditionProductAssetsIncludedMaps.vue?vue&type=template&id=06bfbcec&"
import script from "./MoleculeEditionProductAssetsIncludedMaps.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionProductAssetsIncludedMaps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports